const people =
{
    helmet :
    {
        title : 'Personnes' ,
        metas : []
    }
};

export default people ;